import React from 'react';
import { Button } from '../ui/Button';
export function CTAButton() {
  return <Button variant="primary" size="lg" href="https://form.typeform.com/to/ePFsBam5" className="text-xl px-12 py-6" data-id="element-297">
      Click here to schedule a call
    </Button>;
}